export const types = {
  login: "[Auth] Login",
  logout: "[Auth] Logout",
  reset: "[Auth] RESET",
  error: "[Auth] ERROR",
};
